import { Injectable } from '@angular/core';
import {
  IESDPCaptainReports,
  IESDPFreeTimeGraph,
  IESDPGroupTeams,
  IESDPIterationReview,
  IESDPTeam,
  IESDPTeamDocument,
  IESDPTeamDocuments,
  IESDPTeamIteration,
  IESDPTeamMaterials,
  IESDPTeams,
} from '@interfaces/IESDP';
import { IUsersPagination } from '@interfaces/IUser';
import { IAppState } from '@myStore/app.state';
import {
  EESDPViewActions,
  GenerateESDPTeamsFailure,
  GenerateESDPTeamsRequest,
  GenerateESDPTeamsSuccess,
  GetESDPIterationByIdFailure,
  GetESDPIterationByIdRequest,
  GetESDPIterationByIdSuccess,
  GetESDPIterationCaptainReportsFailure,
  GetESDPIterationCaptainReportsRequest,
  GetESDPIterationCaptainReportsSuccess,
  GetESDPIterationReviewByIdFailure,
  GetESDPIterationReviewByIdRequest,
  GetESDPIterationReviewByIdSuccess,
  GetESDPIterationsFailure,
  GetESDPIterationsRequest,
  GetESDPIterationsSuccess,
  GetESDPTeamFailure,
  GetESDPTeamMentorsFailure,
  GetESDPTeamMentorsRequest,
  GetESDPTeamMentorsSuccess,
  GetESDPTeamRequest,
  GetESDPTeamsFailure,
  GetESDPTeamsRequest,
  GetESDPTeamsSuccess,
  GetESDPTeamStudentsFailure,
  GetESDPTeamStudentsRequest,
  GetESDPTeamStudentsSuccess,
  GetESDPTeamSuccess,
  GetFreeTimeGraphFailure,
  GetFreeTimeGraphRequest,
  GetFreeTimeGraphSuccess,
  GetTeamDocumentByIdFailure,
  GetTeamDocumentByIdRequest,
  GetTeamDocumentByIdSuccess,
  GetTeamDocumentsFailure,
  GetTeamDocumentsRequest,
  GetTeamDocumentsSuccess,
  GetTeamMaterialsFailure,
  GetTeamMaterialsRequest,
  GetTeamMaterialsSuccess,
} from '@myStore/ESDP-view/ESDP.view.actions';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { ESDPViewService } from '@services/ESDP-view/ESDP-view.service';
import { ToastrService } from 'ngx-toastr';
import { catchError, map, switchMap } from 'rxjs/operators';

@Injectable()
export class ESDPViewEffects {
  constructor(
    private _actions$: Actions,
    private _store: Store<IAppState>,
    private _toastr: ToastrService,
    private _ESDPViewService: ESDPViewService
  ) {}

  $getTeam = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetESDPTeamRequest>(EESDPViewActions.GetTeamRequest),
        switchMap(action => {
          return this._ESDPViewService.getTeam(action.id).pipe(
            map((team: IESDPTeam) => {
              this._store.dispatch(new GetESDPTeamSuccess(team));
            }),
            catchError(err => {
              this._toastr.error(
                `При получении группы возникла ошибка (get)`,
                'Что-то пошло не так',
                {
                  timeOut: 3500,
                }
              );
              this._store.dispatch(new GetESDPTeamFailure());
              return err.error;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $getTeams = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetESDPTeamsRequest>(EESDPViewActions.GetTeamsRequest),
        switchMap(action => {
          return this._ESDPViewService.getTeams(action.qParams).pipe(
            map((teams: IESDPGroupTeams[]) => {
              this._store.dispatch(new GetESDPTeamsSuccess(teams));
            }),
            catchError(err => {
              this._toastr.error(
                `При получении групп возникла ошибка (get)`,
                'Что-то пошло не так',
                {
                  timeOut: 3500,
                }
              );
              this._store.dispatch(new GetESDPTeamsFailure(err.error));
              return err.error;
            })
          );
        })
      );
    },
    { dispatch: false }
  );
  $generateTeams = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GenerateESDPTeamsRequest>(
          EESDPViewActions.GenerateESDPTeamsRequest
        ),
        switchMap(action => {
          return this._ESDPViewService.generateTeams(action.qParams).pipe(
            map((teams: IESDPTeams[]) => {
              this._store.dispatch(new GenerateESDPTeamsSuccess(teams));
            }),
            catchError(err => {
              this._toastr.error(
                `При генерации группы возникла ошибка (get)`,
                'Что-то пошло не так',
                {
                  timeOut: 3500,
                }
              );
              this._store.dispatch(new GenerateESDPTeamsFailure(err.error));
              return err.error;
            })
          );
        })
      );
    },
    { dispatch: false }
  );
  $getIterations = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetESDPIterationsRequest>(EESDPViewActions.GetIterationsRequest),
        switchMap(action => {
          return this._ESDPViewService.getIterations(action.qParams).pipe(
            map((iterations: IESDPTeamIteration[]) => {
              this._store.dispatch(new GetESDPIterationsSuccess(iterations));
            }),
            catchError(err => {
              this._toastr.error(
                `При получении итерации возникла ошибка (get)`,
                'Что-то пошло не так',
                {
                  timeOut: 3500,
                }
              );
              this._store.dispatch(new GetESDPIterationsFailure(err.error));
              return err.error;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $getIterationById = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetESDPIterationByIdRequest>(
          EESDPViewActions.GetIterationByIdRequest
        ),
        switchMap(action => {
          return this._ESDPViewService.getIterationById(action.id).pipe(
            map((iterations: IESDPTeamIteration) => {
              this._store.dispatch(new GetESDPIterationByIdSuccess(iterations));
            }),
            catchError(err => {
              this._toastr.error(
                `При получении итерации по id возникла ошибка (get)`,
                'Что-то пошло не так',
                {
                  timeOut: 3500,
                }
              );
              this._store.dispatch(new GetESDPIterationByIdFailure(err.error));
              return err.error;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $getIterationReviewById = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetESDPIterationReviewByIdRequest>(
          EESDPViewActions.GetIterationReviewByIdRequest
        ),
        switchMap(action => {
          return this._ESDPViewService.getIterationReviewById(action.id).pipe(
            map((review: IESDPIterationReview) => {
              this._store.dispatch(
                new GetESDPIterationReviewByIdSuccess(review)
              );
            }),
            catchError(err => {
              this._toastr.error(
                `При получении review итерации по id возникла ошибка (get)`,
                'Что-то пошло не так',
                {
                  timeOut: 3500,
                }
              );
              this._store.dispatch(
                new GetESDPIterationReviewByIdFailure(err.error)
              );
              return err.error;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $getTeamStudents = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetESDPTeamStudentsRequest>(
          EESDPViewActions.GetTeamStudentsRequest
        ),
        switchMap(action => {
          return this._ESDPViewService
            .getTeamStudents(action.teamId, action.qParams)
            .pipe(
              map((students: IUsersPagination) => {
                this._store.dispatch(new GetESDPTeamStudentsSuccess(students));
              }),
              catchError(err => {
                this._toastr.error(
                  `При получении команды возникла ошибка (get)`,
                  'Что-то пошло не так',
                  {
                    timeOut: 3500,
                  }
                );
                this._store.dispatch(new GetESDPTeamStudentsFailure(err.error));
                return err.statusText;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  $getTeamMentors = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetESDPTeamMentorsRequest>(
          EESDPViewActions.GetTeamMentorsRequest
        ),
        switchMap(action => {
          return this._ESDPViewService
            .getTeamMentors(action.teamId, action.qParams)
            .pipe(
              map((mentors: IUsersPagination) => {
                this._store.dispatch(new GetESDPTeamMentorsSuccess(mentors));
              }),
              catchError(err => {
                this._toastr.error(
                  `При получении ментора команды возникла ошибка (get)`,
                  'Что-то пошло не так',
                  {
                    timeOut: 3500,
                  }
                );
                this._store.dispatch(new GetESDPTeamMentorsFailure(err.error));
                return err.statusText;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  $getTeamDocuments = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetTeamDocumentsRequest>(
          EESDPViewActions.GetTeamDocumentsRequest
        ),
        switchMap(action => {
          return this._ESDPViewService.getTeamDocuments(action.qParams).pipe(
            map((documents: IESDPTeamDocuments) => {
              this._store.dispatch(new GetTeamDocumentsSuccess(documents));
            }),
            catchError(err => {
              this._toastr.error(
                `При получении документов группы возникла ошибка (get)`,
                'Что-то пошло не так',
                {
                  timeOut: 3500,
                }
              );
              this._store.dispatch(new GetTeamDocumentsFailure(err.error));
              return err.statusText;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $getTeamDocumentById = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetTeamDocumentByIdRequest>(
          EESDPViewActions.GetTeamDocumentByIdRequest
        ),
        switchMap(action => {
          return this._ESDPViewService.getTeamDocumentById(action.id).pipe(
            map((document: IESDPTeamDocument) => {
              this._store.dispatch(new GetTeamDocumentByIdSuccess(document));
            }),
            catchError(err => {
              this._toastr.error(
                `При получении документов группы по id возникла ошибка (get)`,
                'Что-то пошло не так',
                {
                  timeOut: 3500,
                }
              );
              this._store.dispatch(new GetTeamDocumentByIdFailure(err.error));
              return err.statusText;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $getTeamMaterials = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetTeamMaterialsRequest>(
          EESDPViewActions.GetTeamMaterialsRequest
        ),
        switchMap(action => {
          return this._ESDPViewService.getTeamMaterials(action.team_id).pipe(
            map((materials: IESDPTeamMaterials[]) => {
              this._store.dispatch(new GetTeamMaterialsSuccess(materials));
            }),
            catchError(err => {
              this._toastr.error(
                `При получении материалов группы возникла ошибка (get)`,
                'Что-то пошло не так',
                {
                  timeOut: 3500,
                }
              );
              this._store.dispatch(new GetTeamMaterialsFailure(err.error));
              return err.statusText;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $getIterationCaptainReports = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetESDPIterationCaptainReportsRequest>(
          EESDPViewActions.GetIterationCaptainReportsRequest
        ),
        switchMap(action => {
          return this._ESDPViewService
            .getIterationCaptainReports(action.id)
            .pipe(
              map((reports: IESDPCaptainReports) => {
                this._store.dispatch(
                  new GetESDPIterationCaptainReportsSuccess(reports)
                );
              }),
              catchError(err => {
                this._toastr.error(
                  `При получении рапорта капитана возникла ошибка (get)`,
                  'Что-то пошло не так',
                  {
                    timeOut: 3500,
                  }
                );
                this._store.dispatch(
                  new GetESDPIterationCaptainReportsFailure(err.error)
                );
                return err.statusText;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  $getFreeTimeGraph = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetFreeTimeGraphRequest>(
          EESDPViewActions.GetFreeTimeGraphRequest
        ),
        switchMap(action => {
          return this._ESDPViewService.getFreeTimeGraph(action.id).pipe(
            map((data: IESDPFreeTimeGraph) => {
              this._store.dispatch(new GetFreeTimeGraphSuccess(data));
            }),
            catchError(err => {
              this._store.dispatch(new GetFreeTimeGraphFailure(err));
              return err.error;
            })
          );
        })
      );
    },
    { dispatch: false }
  );
}
